// Module
var code = "<ng-form> <kform-builder-option-key></kform-builder-option-key> <kform-builder-option property=\"kdata.type_kid\" label=\"Data type\" disabled=\"disabled\"></kform-builder-option> <kform-builder-option-path></kform-builder-option-path> </ng-form> ";
// Exports
export default code;